import { NumberHash } from '@app/shared/utils/utils-types';

export class ErrorDescriptionHash implements NumberHash<string> {
  [name: number]: string;
}

export const errorDescriptionString = new ErrorDescriptionHash();

export function updateErrorDescriptions(errorDesc: ErrorDescriptionHash) {
  for (const key in errorDesc) {
    if (Object.prototype.hasOwnProperty.call(errorDesc, key)) {
      errorDescriptionString[key] = errorDesc[key];
    }
  }
}
